import React from "react"
import Link from "gatsby-link";
// import menu from '../scripts/menu.js';
import '../styles/index.scss';
import '../styles/utils.scss';


import Banner from '../components/Banner';
import Button from '../components/Button';
import Content from '../components/Content';
import Client from '../components/Client';
import Footer from '../components/Footer';
import Form from '../components/Form';
import HalfHero from '../components/HalfHero';
import Header from '../components/Header';
import Hero from '../components/Hero';
import IconList from '../components/IconList';
import Testimonial from '../components/Testimonial';
import Testimonials from '../components/Testimonials';


export default () => 
<div>
  <Banner>
    <h1>Contact Us</h1>
  </Banner>
</div>



// WEBPACK FOOTER //
// ./src/pages/contact.js